
let list = [
    {
        name: 'Birmingham.jpeg',
        title: `Itay's Birmingham`,
        address: '42 Fairey Street, Birmingham, <br/> B45 8GW',
        addressNoHTML: '42 Fairey Street, Birmingham, B45 8GW',
        coordinates: [52.382151, -1.987970],
        phoneNumber: '+44 121 692 1114'
    },
    {
        name: 'Edinburgh.jpg',
        title: `Itay's Edinburgh`,
        address: '12 Main St, Edinburgh, <br/> EH4 5BY',
        addressNoHTML: '12 Main St, Edinburgh, EH4 5BY',
        coordinates: [55.965476, -3.274018],
        phoneNumber: '+44 131 336 1157'
    },
    {
        name: 'Glasgow.jpg',
        title: `Itay's Glasgow`,
        address: '10 Cromdale Rd, Port Glasgow, <br/> PA14 6LT',
        addressNoHTML: '10 Cromdale Rd, Port Glasgow, PA14 6LT',
        coordinates: [55.919604, -4.657940],
        phoneNumber: '+44 141 204 2081'
    },
    {
        name: 'Liverpool.png',
        title: `Itay's Liverpool`,
        address: '85 Bold St, Liverpool, <br/> L1 4HF',
        addressNoHTML: '85 Bold St, Liverpool, L1 4HF',
        coordinates: [53.402591, -2.976950],
        phoneNumber: '+44 151 230 8600'
    },
    {
        name: 'London.jpg',
        title: `Itay's London`,
        address: '60 Cross Street, London, <br/> N1 2BA',
        addressNoHTML: '60 Cross Street, London, N1 2BA',
        coordinates: [51.539520, -0.101495],
        phoneNumber: '+44 20 7434 1500'
    },
    {
        name: 'Manchester.jpg',
        title: `Itay's Manchester`,
        address: '101 Portland St, Manchester, <br/> M1 6DF',
        addressNoHTML: '101 Portland St, Manchester, M1 6DF',
        coordinates: [53.477528, -2.239738],
        phoneNumber: '+44 161 694 8585'
    }]

export default list;